<!-- Learning Panel toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #learningPanelOrigin>
    <ng-container *ngIf="suggestedCourses?.length > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3 animate-bounce">
            <span class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                {{suggestedCourses?.length}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
</button>


<!-- Learning Panel -->
<ng-template #learningPanel>
    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:rounded-2xl overflow-hidden shadow-2xl">
        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <button mat-icon-button *ngIf="selectedCourse" (click)="selectedCourse=null" class="mr-3">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-small-left'" class="text-on-primary"></mat-icon>
            </button>
            <mat-form-field
                *ngIf="!selectedCourse"
                class="w-full dark:bg-default dark:rounded-lg"
                [subscriptSizing]="'dynamic'">
                <mat-icon
                    matPrefix
                    class="icon-size-5"
                    [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                <input
                    (input)="filterByQuery(query.value)"
                    [placeholder]="'Search by title or description' | transloco"
                    matInput
                    #query>
            </mat-form-field>
        </div>
        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:h-180 sm:max-h-120 overflow-y-auto bg-card min-w-120 p-4">

            <ng-container *ngIf="suggestedCourses?.length > 0 && !selectedCourse">
                <div class="text-lg font-bold text-secondary">Cursuri sugerate</div>
                <div class="text-sm text-secondary mb-4">Bazat pe ce se afișează acum pe ecran</div>
                <ng-container *ngFor="let suggestedCourse of suggestedCourses; trackBy: trackByFn">
                    <div (click)="updateSelectedCourse(suggestedCourse)" class="cursor-pointer">
                        <ng-container *ngTemplateOutlet="courseEntry; context: {$implicit: suggestedCourse, highlight:true}"></ng-container>
                    </div>
                </ng-container>
                <hr class="my-4">
            </ng-container>

            <ng-container *ngIf="!selectedCourse">
                <div class="text-lg text-secondary">Cursuri disponibile ({{courses?.length}})</div>
                <div class="flex flex-col mt-2 gap-4">
                    <ng-container *ngFor="let course of filteredCourses; trackBy: trackByFn">
                        <!-- Course Entry -->
                        <div (click)="updateSelectedCourse(course)" class="cursor-pointer">
                            <ng-container *ngTemplateOutlet="courseEntry; context: {$implicit: course, highlight:false}"></ng-container>
                            <mat-divider class="mt-4"></mat-divider>
                        </div>

                    </ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="selectedCourse && !selectedStep">
                <div class="text-lg font-bold text-secondary w-full text-center">{{selectedCourse?.title}}</div>
                <mat-divider class="my-4 border-2"></mat-divider>
                <div class="flex flex-col mt-2 gap-4">
                    <ng-container *ngFor="let courseStep of selectedCourse.steps">
                        <!-- Course steps -->
                        <div (click)="updateSelectedStep(courseStep)" class="cursor-pointer">
                            <ng-container *ngTemplateOutlet="stepEntry; context: {$implicit: courseStep}"></ng-container>
                            <mat-divider class="mt-4"></mat-divider>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="selectedStep && selectedCourse">
<!--                order?: number;-->
<!--                title?: string;-->
<!--                subtitle?: string;-->
<!--                content?: string;-->
<!--                videoId?: string;-->
<!--                length?: number;                -->
                <div class="text-lg text-secondary">{{selectedStep?.title}}</div>
                <div class="text-sm text-secondary">{{selectedStep?.subtitle}}</div>
                <div [innerHTML]="selectedStep?.content"></div>
                <youtube-video *ngIf="selectedStep?.videoId" [video_id]="selectedStep?.videoId"></youtube-video>
                <div class="flex flex-col mt-2 gap-4">

                </div>
            </ng-container>

        </div>
    </div>
</ng-template>

<!-- Course Entry -->
<ng-template
    #courseEntry
    let-course
    let-highlight_val="highlight">
    <div class="flex items-center cursor-pointer group">
        <!-- Icon -->
        <div class="flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full bg-default text-on-primary group-hover:scale-125 transition-transform duration-500"
        [ngClass]="{'bg-primary-200 text-primary dark:bg-primary-800 dark:text-primary-50 animate-pulse': highlight_val}"
        >
            <mat-icon
                class="icon-size-5"
                [svgIcon]="'heroicons_solid:academic-cap'">
<!--                play-circle-->
            </mat-icon>
        </div>
        <!-- Title & Info -->
        <div class="flex flex-col min-w-0">
            <div class="font-medium truncate group-hover:text-primary transition-colors duration-150"
                 [ngClass]="{'text-lg font-bold': highlight_val}">
                {{course.title}}
            </div>
            <div class="flex items-center mt-0.5 text-md text-secondary truncate">
                <!-- Course time -->
                <div class="flex items-center leading-5 text-md text-secondary">
                    <mat-icon
                        class="icon-size-4 text-hint"
                        [svgIcon]="'heroicons_solid:academic-cap'"></mat-icon>
                    <div *ngIf="course.totalSteps == 1" class="ml-1.5">{{course.totalSteps}} lectie</div>
                    <div *ngIf="course.totalSteps != 1" class="ml-1.5">{{course.totalSteps}} lectii</div>
                </div>
                <span class="mx-1.5">&bull;</span>
                <!-- Course time -->
                <div class="flex items-center leading-5 text-md text-secondary">
                    <mat-icon
                        class="icon-size-4 text-hint"
                        [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                    <div *ngIf="course.duration.hours == 1" class="ml-1.5">{{course.duration.hours}} ora</div>
                    <div *ngIf="course.duration.hours > 1" class="ml-1.5">{{course.duration.hours}} ore</div>
                    <div *ngIf="course.duration.minutes >= 1" class="ml-1.5">{{course.duration.minutes}} min</div>
                    <div *ngIf="course.duration.seconds >= 1" class="ml-1.5">{{course.duration.seconds}} sec</div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- Step Entry -->
<ng-template
    #stepEntry
    let-stepE>
    <div class="flex items-center cursor-pointer group">
        <!-- Icon -->
        <div class="flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full bg-primary-100 text-primary dark:bg-primary-600 dark:text-primary-50 group-hover:scale-125 transition-transform duration-500">
            <mat-icon
                class="icon-size-5"
                [svgIcon]="'heroicons_outline:play-circle'">
            </mat-icon>
        </div>
        <!-- Title & Info -->
        <div class="flex flex-col min-w-0">
            <div class="font-medium truncate group-hover:text-primary transition-colors duration-150">
                {{stepE.order +1}}. {{stepE.title}}
            </div>
            <div class="text-hint text-sm font-medium truncate group-hover:text-primary transition-colors duration-150">
                {{stepE.subtitle}}
            </div>
            <div class="flex items-center mt-0.5 text-md text-secondary truncate">
                <!-- Course time -->
                <div class="flex items-center leading-5 text-md text-secondary">
                    <mat-icon
                        class="icon-size-4 text-hint"
                        [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                    <div *ngIf="stepE.duration.hours == 1" class="ml-1.5">{{stepE.duration.hours}} ora</div>
                    <div *ngIf="stepE.duration.hours > 1" class="ml-1.5">{{stepE.duration.hours}} ore</div>
                    <div *ngIf="stepE.duration.minutes >= 1" class="ml-1.5">{{stepE.duration.minutes}} min</div>
                    <div *ngIf="stepE.duration.seconds >= 1" class="ml-1.5">{{stepE.duration.seconds}} sec</div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
